import { TaskQueryParams } from "../../../../../lib/api/resources/tasks";
import { TaskFilterValues } from "../types/TaskFilterValues.interface";

export const buildTaskApiFilters = (
  filterValues: TaskFilterValues,
): Partial<TaskQueryParams> => {
  const apiFilters: Partial<TaskQueryParams> = {};

  if (filterValues.description) {
    apiFilters.description = filterValues.description;
  }

  if (filterValues.status) {
    apiFilters.status = filterValues.status;
  }

  if (filterValues.priority) {
    apiFilters.priority = filterValues.priority;
  }

  return apiFilters;
};
